import * as React from 'react';
import { useTranslate, useGetList } from 'react-admin';
import CardWithIcon from './CardWithIcon';

import BusinessIcon from '@mui/icons-material/Business';

const TotalProducers = () => {
    const translate = useTranslate();

    const { total } = useGetList('producers');
    return (
        <CardWithIcon
            to="/producers"
            icon={BusinessIcon}
            title="Producteurs"
            subtitle={total}
        />
    );
};

export default TotalProducers;